import { FC, SVGProps } from 'react';

interface ITableEmptyState {
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export const TableEmptyState: FC<ITableEmptyState> = ({
  icon: Icon,
  title,
  description,
  buttonText,
  onButtonClick,
}) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center py-20">
      <div className="w-12 h-12 rounded-xl border border-slate-medium flex items-center justify-center mb-4">
        <Icon className="w-5 h-5 text-text" />
      </div>
      <h3 className="semibold text-base text-text">{title}</h3>
      <p className="text-sm text-text-placeholder mt-1">{description}</p>
      {buttonText && onButtonClick && (
        <button
          onClick={onButtonClick}
          className="mt-4 bg-primary text-white text-sm medium px-5 py-2.5 rounded-lg flex items-center gap-2 hover:opacity-90 transition-opacity"
        >
          <span className="text-lg leading-none">+</span>
          {buttonText}
        </button>
      )}
    </div>
  );
};
